// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "CardGroup-module--bx--text-truncate--end--219ht";
export var bxTextTruncateFront = "CardGroup-module--bx--text-truncate--front--3CqAz";
export var cardGroup = "CardGroup-module--cardGroup--1MdkW";